import React, { memo } from 'react';

import Popup from '../../../helpers/Popup';
import FormGroup from '../../../helpers/FormGroup';
import Button from '../../../helpers/Button';
import BaseInput from '../../../helpers/Input';
import ErrorDisplay from '../../../decorators/DisplayError';
import PrettyError from '../../../decorators/PrettyError';
import style from './style.module.css';

const Input = PrettyError(ErrorDisplay(BaseInput));

const CustomFormatComponent = ({ isNew, onChange, channel, onSave, onUndo }) => {
  const header = <div>{`${isNew ? 'Create' : 'Change'} contact profile info`} - Custom</div>;

  const footer = [
    <Button key="undo" onClick={onUndo}>
      Undo
    </Button>,
    <Button key="save" className="btn-primary" onClick={onSave}>
      {isNew ? 'Create' : 'Save'}
    </Button>,
  ];

  return (
    <Popup className={style.host} footer={footer} header={header} id="extFormatContact">
      <div className="row">
        <FormGroup className="col-sm-6">
          <Input
            className="input-md"
            label="Phone"
            maxLength="50"
            name="unformattedPhone"
            onChange={onChange}
            placeholder="Phone"
            root={channel}
            autoFocus
            deep
            showLabel
          />
        </FormGroup>
        <FormGroup className="col-sm-6">
          <label className="field-label" htmlFor="custom-phone-type">
            Type
          </label>
          <div className={style.typeField}>
            <span className={style.typePrefix}>Custom -</span>
            <Input
              className="input-md"
              id="custom-phone-type"
              label="Type"
              maxLength="30"
              name="type"
              onChange={onChange}
              placeholder="Type"
              root={channel}
              deep
            />
          </div>
        </FormGroup>
      </div>
    </Popup>
  );
};

export const CustomFormat = memo(CustomFormatComponent);
